import { render } from "./navigation-bar.html?vue&type=template&id=00b3e63d&scoped=true&ts=true&external"
import script from "./navigation-bar.ts?vue&type=script&lang=ts&external"
export * from "./navigation-bar.ts?vue&type=script&lang=ts&external"

import "./navigation-bar.scss?vue&type=style&index=0&id=00b3e63d&scoped=true&lang=scss&external"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-00b3e63d"]])

export default __exports__